import MyUHLParcelsContainer from "../containers/MyUHLParcelsContainer";

const MyUHLParcelsPage = () => {
    return <MyUHLParcelsContainer />;
};

export default MyUHLParcelsPage;
